export enum UserContentStatusType {
  NEW = 'NEW',
  REVIEWED = 'REVIEWED',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}
